// extracted by mini-css-extract-plugin
export default {"active":"styles-module__active__src-labstep-web-screens-Device-Index-Breadcrumb-_cgg4O"};